<template>
    <modal name="insurancePriceSrchPopup" :width="850" :height="600" :clickToClose="false" @before-open="beforeOpen" @opened="opened">
        <div id="div_insurancePriceSrch" class="popup on">
            <div class="pop_tit">
                보험가격 조회
            </div>
            <div id="div_insurancePriceSrchPopupScroll" class="scroll_area pop_con_wrap" style="height:500px;">
                    <div class="pop_search_bg">
                        <div class="input-group-02">
                            <div class="colum-02 col-35">
                                <div class="form_box-02">
                                    <div class="pro_text">
                                        <span>상품코드</span>
                                        <span>EK5W30LL67DL</span>
                                    </div>
                                </div>
                            </div>
                            <div class="colum-02">
                                <div class="form_box-02">
                                <div class="pro_text">
                                        <span>상품명</span>
                                        <span>AMBANOL(마바눌) 5W30 롱라이프 LL (BOX)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pop_search_bg">
                        <div class="board_list type02">
                            <div class="ins_search_wrap">
                                <div class="ins_search">
                                    <div class="board_list type02 ins_table">
                                        <table class="board_table" id="inst">
                                        <caption class="hide">보험담당자 조회 테이블</caption>
                                        <colgroup>
                                        <col style="width:10%">
                                        <col style="width:">
                                        <col style="width:">
                                        </colgroup>
                                        <tbody>
                                        <tr v-bind:class="{'ins_over' : classObject(option.text)}" v-bind:id="option.text" v-for="(option, index) in sliceItems(0, 7)" v-bind:value="option.value" v-bind:key="option.text">
                                            <td>
                                               {{index + 1}} 
                                            </td>
                                            <td>
                                                {{option.text}}
                                            </td>
                                            <td>
                                                {{option.value}}
                                            </td>
                                        </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="ins_search">
                                    <div class="board_list type02 ins_table">
                                        <table class="board_table">
                                        <caption class="hide">보험담당자 조회 테이블</caption>
                                        <colgroup>
                                        <col style="width:10%">
                                        <col style="width:">
                                        <col style="width:">
                                        </colgroup>
                                        <tbody>
                                            <tr v-for="(option, index) in sliceItems(7, 14)" v-bind:value="option.value" v-bind:key="option.text">
                                                <td>
                                                {{index + 8}} 
                                                </td>
                                                <td>
                                                    {{option.text}}
                                                </td>
                                                <td>
                                                    {{option.value}}
                                                </td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>

            <div class="pop_footer_wrap">
                <div class="btn_area mt0">
                    <a href="javascript:void(0);" class="button blue" @click="sendInsrncPriceInfo"><span>선택</span></a>
                </div>
            </div>
            <a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
        </div>
    </modal>
</template>

<script>
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import Vue from 'vue'

export default {
    name : 'insurancePriceSrchPopup',
    components : { Grid, GridModule, Vue },
    props : {
        value : '',
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            //pushToParent: '',
            transfer : [],
            carName : '',
            myInsuranceName: '',
            selectBox_options : {
                brandCodeVo : ''
            },
            grid_options : {
                general : {
                  id  : 'detail-car-model-popup-grid',
                  search : '/brand/list',
                  excel : false,    
                  type : {
                      isUpdate : false,
                      //isHideAdd : true : true,
                  },
                  params : {
                      manufactor: '',
                      carModelName: '',
                      carModelDetail: ''
                  }
                },
                grid_options : {
                    height: 240,
                    autoColumnIndex: true,
                    // rowindexColumnFromZero: false,
                    rowSelectOption:{
                        clickSelect: true,
                        singleSelect: true,
                        radioColumn: true,
                        allowSingleUnselect: false
                    },
                    paging: {
                        pagerTotal : false,
                        // hidePageList : false,
                        pagerSelect : false
                    },
                    
                    columnMapping : [
                        //{   key : 'brandId',          hidden: true },
                        //{   width : '30px',            selectorColumn : true   },
                        {   selectorColumn : true ,   title : '선택',          width : '46px', align : 'center' },
                        {   key : 'brandName',     title : '모델상세/배기량/원통기형식',      width : '370px', align : 'center'  },
                        {   key : 'brandEngName',     title : '차종코드',      width : '150px', align : 'center'  },
                        {   key : 'brandId',     title : '국내사양',      width : '100px', align : 'center'  },
                        {   key : 'sailDiscountRate',     title : '빈도',          width : '100px', align : 'center'  }
                    ]
                }
            }
        }
    },
    created() {
        //alert("created");
    },
    mounted () {
        //alert("mounted");
    },
    computed: {
        // classObject(data) {
        //     return {
        //         //ins_over : this.isClassActive == '혼다'
        //     }
        // }
    },
    methods : {
        beforeOpen(e) {
            //변수 초기화
            this.transfer = [];
            this.carName = '';
            this.myInsuranceName = '';
            this.grid_options.general.params.manufactor = '';
            this.grid_options.general.params.carModelName = '';
            this.grid_options.general.params.carModelDetail = '';
            //보험 정보 세팅
            this.getInsrcPriceInfo();
        },
        opened(e) {
            //나의 보험에 해당하는 곳 클래스 적용
            this.myInsuranceName = 'BMW';

            //팝업창 스크롤바 css 컨트롤(공통)
            $("#div_insurancePriceSrchPopupScroll").mCustomScrollbar( {
                theme: "dark-thick",
                scrollInertia: 500
            });
            //팝업창 닫기 관련 css 컨트롤(공통)
            $("#div_insurancePriceSrch").parent().css('overflow', 'visible');
        },
        close() {
            this.$modal.hide('insurancePriceSrchPopup');
        },
        searchDetailCarModel() {
            this.grid_options.general.PageInfo.current = 1;
            //alert("그리드검색세팅::" + JSON.stringify(this.grid_options.general.params));
            GridModule.searchData(this.grid_options);
        },
        sendInsrncPriceInfo(e) {
            // var data = $('#' + this.grid_options.general.id).alopexGrid('dataGet', {_state: {selected:true}});
            // for(var key in data) {
            //     this.transfer.push(data[key]);
            // }
            //alert("transfer::" + JSON.stringify(this.transfer));
            //alert("transfer.brandName::" + this.transfer[0].brandName);


            alert("???:::" + JSON.stringify(e));

            // this.carName = this.transfer[0].brandName;

            // this.$emit('insrnc-price-srch-popup-complete', this.carName);
            // this.$modal.hide('insurancePriceSrchPopup');
        },
        getInsrcPriceInfo() {
            //브랜드 코드 데이터 가져와서 셀렉트박스 넣기
            let serverPageInfo = { current :  1, perPage : 9999};
            Vue.httpClient
            .get('/brand/list', {params : serverPageInfo})
            .then((result) => {
                if ( result.data.result ) {
                let list = result.data.result.list;
                let brandCodeVo = [];
                for(var key in list) {
                    brandCodeVo.push({'value':list[key].brandNo, 'text':list[key].brandEngName});
                }
                this.selectBox_options.brandCodeVo = brandCodeVo;
                }
            })
        },
        sliceItems(start, end) {
            return this.selectBox_options.brandCodeVo.slice(start, end);
        },
        classObject(data) {
            //현재 BMW로 하드코딩된 상태
            //자신이 선택한 보험사는 빨간색으로 세팅
            if(data == this.myInsuranceName) return true;
            else false;
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/views/common/InsurancePriceSrchPopup.vue